import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();
const includes = ["internalInvoice", "storable", "unitOfMeasureUnit", "orderItem"];
const resource = "establishment-internal-invoice-items";

function list(params = {}) {
  const options = {
    params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/${resource}`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    params: {
      include: includes.join(","),
    },
  };
  return axios
    .get(`${url}/${resource}/${id}?include=`, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function add(item) {
  const payload = jsona.serialize({
    stuff: item,
    includeNames: ["internalInvoice", "storable", "unitOfMeasureUnit"],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/${resource}?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(item) {
  const payload = jsona.serialize({
    stuff: item,
    includeNames: ["internalInvoice", "storable", "unitOfMeasureUnit"],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/${resource}/${item.id}?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  return axios.delete(`${url}/${resource}/${id}?include=`).then(() => {
    return true;
  });
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
